<template>
  <div
    class="layout--main"
    :class="[
      layoutTypeClass,
      navbarClasses,
      footerClasses,
      { 'no-scroll': isAppPage },
    ]"
  >
    <v-nav-menu
      :navMenuItems="filteredNav"
      title="PMS"
      parent=".layout--main"
    />

    <div
      id="content-area"
      :class="[contentAreaClass, { 'show-overlay': bodyOverlay }]"
    >
      <div id="content-overlay" />

      <!-- Navbar -->
      <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
        <the-navbar-horizontal
          :navbarType="navbarType"
          :class="[
            { 'text-white': isNavbarDark && !isThemeDark },
            { 'text-base': !isNavbarDark && isThemeDark },
          ]"
        />

        <div style="height: 62px" v-if="navbarType === 'static'"></div>

        <h-nav-menu
          :class="[
            { 'text-white': isNavbarDark && !isThemeDark },
            { 'text-base': !isNavbarDark && isThemeDark },
          ]"
          :navMenuItems="filteredNav"
        />
      </template>

      <template v-else>
        <the-navbar-vertical
          :navbarColor="navbarColor"
          :class="[
            { 'text-white': isNavbarDark && !isThemeDark },
            { 'text-base': !isNavbarDark && isThemeDark },
          ]"
        />
      </template>
      <!-- /Navbar -->

      <div class="content-wrapper">
        <div class="router-view">
          <div class="router-content">
            <transition :name="routerTransition">
              <div
                v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
                class="router-header flex flex-wrap items-center mb-6"
              >
                <!-- <div
                  class="content-area__heading"
                  :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}"
                >
                  <h2 class="mb-1">{{ routeTitle }}</h2>
                </div>-->

                <!-- BREADCRUMB -->
                <!-- <vx-breadcrumb
                  class="ml-4 md:block hidden"
                  v-if="$route.meta.breadcrumb"
                  :route="$route"
                  :isRTL="$vs.rtl"
                />-->

                <!-- DROPDOWN -->
                <!-- <vs-dropdown vs-trigger-click class="ml-auto md:block hidden cursor-pointer">
                  <vs-button radius icon="icon-settings" icon-pack="feather" />

                  <vs-dropdown-menu class="w-32">
                    <vs-dropdown-item>
                      <div
                        @click="$router.push('/pages/profile').catch(() => {})"
                        class="flex items-center"
                      >
                        <feather-icon
                          icon="UserIcon"
                          class="inline-block mr-2"
                          svgClasses="w-4 h-4"
                        />
                        <span>Profile</span>
                      </div>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                      <div
                        @click="$router.push('/apps/todo').catch(() => {})"
                        class="flex items-center"
                      >
                        <feather-icon
                          icon="CheckSquareIcon"
                          class="inline-block mr-2"
                          svgClasses="w-4 h-4"
                        />
                        <span>Tasks</span>
                      </div>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                      <div
                        @click="$router.push('/apps/email').catch(() => {})"
                        class="flex items-center"
                      >
                        <feather-icon
                          icon="MailIcon"
                          class="inline-block mr-2"
                          svgClasses="w-4 h-4"
                        />
                        <span>Inbox</span>
                      </div>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>-->
              </div>
            </transition>

            <div class="content-area__content">
              <back-to-top
                bottom="5%"
                :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'"
                visibleoffset="500"
                v-if="!hideScrollToTop"
              >
                <vs-button
                  icon-pack="feather"
                  icon="icon-arrow-up"
                  class="shadow-lg btn-back-to-top"
                />
              </back-to-top>

              <transition :name="routerTransition" mode="out-in">
                <router-view
                  @changeRouteTitle="changeRouteTitle"
                  @setAppClasses="
                    (classesStr) => $emit('setAppClasses', classesStr)
                  "
                />
              </transition>
            </div>
          </div>
        </div>
      </div>
      <the-footer />
    </div>
  </div>
</template>


<script>
import BackToTop from "vue-backtotop";
import HNavMenu from "@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue";
// import navMenuItems from "@/layouts/components/vertical-nav-menu/navMenuItems.js";
import TheNavbarHorizontal from "@/layouts/components/navbar/TheNavbarHorizontal.vue";
import TheNavbarVertical from "@/layouts/components/navbar/TheNavbarVertical.vue";
import TheFooter from "@/layouts/components/TheFooter.vue";
import themeConfig from "@/../themeConfig.js";
import VNavMenu from "@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue";

import { helperMixin } from "../../mixin/helperMixin";

import { mapGetters } from "vuex";
export default {
  mixins: [helperMixin],

  components: {
    BackToTop,
    HNavMenu,
    TheFooter,
    TheNavbarHorizontal,
    TheNavbarVertical,
    VNavMenu,
  },

  data() {
    return {
      footerType: themeConfig.footerType || "static",
      hideScrollToTop: themeConfig.hideScrollToTop,
      isNavbarDark: false,
      navbarColor: themeConfig.navbarColor || "#fff",
      navbarType: themeConfig.navbarType || "floating",
      navMenuItems: [
        {
          url: "/dashboard/branchUser",
          name: "Dashboard User",
          slug: "dashboard",
          icon: "HomeIcon",
          permissionName: "Dashboard Branch User",
        },

        {
          url: "/dashboard/branchHOD",
          name: "Dashboard HOD",
          slug: "dashboard",
          icon: "HomeIcon",
          permissionName: "Dashboard HOD",
        },

        {
          url: "/dashboard/procurement",
          name: "Dashboard Procurement",
          slug: "dashboard",
          icon: "HomeIcon",
          permissionName: "",
        },

        {
          url: "/dashboard/vendor",
          name: "Dashboard vendor",
          slug: "dashboard",
          icon: "HomeIcon",
          permissionName: "Dashboard PR",
        },

        {
          url: "/register",
          name: "Register",
          slug: "pages-register",
          i18n: "Register",
          target: "_blank",
          permissionName: "Register",
        },

        {
          url: null,
          name: "HOD Contract Approval",
          icon: "BriefcaseIcon",
          i18n: "Finance Manager",
          permissionName: "HOD Contract Approver",
          submenu: [
            {
              url: "/form/contract/HOD Pending Contract",
              name: "Pending Approval",
              slug: "new-contract",
              i18n: "View",
              permissionName: "HOD Pending Contract",
            },
            {
              url: "/form/contract/HOD Approved Contract",
              name: "Approved By HOD",
              slug: "sent-hod-contract",
              i18n: "View",
              permissionName: "HOD Approved Contract",
            },
            {
              url: "/form/contract/HOD Rejected Contract",
              name: "Rejected By HOD",
              slug: "rejected-contract",
              i18n: "View",
              permissionName: "HOD Rejected Contract",
            },
          ],
        },

        {
          url: null,
          name: "Report",
          icon: "BriefcaseIcon",
          i18n: "Report",
          permissionName: "pr report",
          submenu: [
            {
              url: "/report/purchaseRequests",
              name: "Purchase Request",
              slug: "new-contract",
              i18n: "View",
              permissionName: "pr report",
            },
            {
              url: "/report/purchaseOrders",
              name: "Purchase Orders",
              slug: "new-contract",
              i18n: "View",
              permissionName: "pr report",
            },
            {
              url: "/report/grns",
              name: "GRN",
              slug: "grn",
              i18n: "View",
              permissionName: "pr report",
            },
            {
              url: "/report/vendors",
              name: "Vendors",
              slug: "vendor",
              i18n: "View",
              permissionName: "pr report",
            },
          ],
        },

        {
          url: null,
          name: "Report",
          icon: "ListIcon",
          i18n: "Report",
          permissionName: "Branch User Report",
          submenu: [
            {
              url: "/form/PR/userPR",
              name: "Purchase Request",
              slug: "new-contract",
              i18n: "View",
              permissionName: "Branch User Report",
            },
            {
              url: "/report/userPO",
              name: "Purchase Orders",
              slug: "new-contract",
              i18n: "View",
              permissionName: "Branch User Report",
            },
          ],
        },

        {
          url: null,
          name: "Proc Contract Approval",
          icon: "BriefcaseIcon",
          i18n: "Finance Manager",
          permissionName: "Contract Approver",
          submenu: [
            {
              url: "/form/contract/procPendingApproval",
              name: "Pending Approval",
              slug: "new-contract",
              i18n: "View",
              permissionName: "Proc Pending Contract",
            },
            {
              url: "/form/contract/Proc Approved Contracts",
              name: "Approved by Procurement",
              slug: "approve-by-procurement",
              i18n: "View",
              permissionName: "Proc Sent HOD Contract",
            },
            {
              url: "/form/contract/Proc Rejected Contract",
              name: "Rejected Contract",
              slug: "rejected-contract",
              i18n: "View",
              permissionName: "Proc Rejected Contract",
            },
          ],
        },

        {
          url: null,
          name: "Contract Manager",
          icon: "BriefcaseIcon",
          i18n: "Finance Manager",
          permissionName: "View Contract",
          submenu: [
            {
              url: "/form/contract/New Contracts",
              name: "New Contracts",
              slug: "new-contract",
              i18n: "View",
              permissionName: "New Contracts",
            },
            {
              url: "/form/contract/submittedToHOD",
              name: "Pending HOD Approval",
              slug: "contract-pending",
              i18n: "View",
              permissionName: "Contracts Submitted Proc",
            },
            {
              url: "/form/contract/ProcApprovedContract",
              name: "Approved By Proc",
              slug: "approved-by-proc-contract",
              i18n: "View",
              permissionName: "Contracts Submitted HOD",
            },
            {
              url: "/form/contract/HODApprovedContract",
              name: "Approved By HOD",
              slug: "approved-by-hod-contract",
              i18n: "View",
              permissionName: "Contracts Approved",
            },
            {
              url: "/form/contract/ProcRejectedContract",
              name: "Rejected By Proc",
              slug: "rejected-contract",
              i18n: "View",
              permissionName: "Contracts Rejected Proc",
            },
            {
              url: "/form/contract/HODRejectedContract",
              name: "Rejected By HOD",
              slug: "rejected-contract",
              i18n: "View",
              permissionName: "Contracts Rejected HOD",
            },
          ],
        },

        // Contract PR for Branch User=====================
        {
          url: null,
          name: "Contract PR",
          icon: "BriefcaseIcon",
          i18n: "Finance Manager",
          permissionName: "View Contract",
          submenu: [
            {
              url: "/form/contractPR/newContractPr",
              name: "New PR",
              slug: "new-contract",
              i18n: "View",
              permissionName: "New Contracts",
            },
            {
              url: "/form/contractPR/Submitted HOD",
              name: "Pending Approval",
              slug: "app-user-edit",
              i18n: "Edit",
              permissionName: "Submitted HOD",
            },
            {
              url: "/form/contractPR/PO Generated",
              name: "PR Approved",
              slug: "app-user-edit",
              i18n: "Edit",
              permissionName: "Submitted HOD",
            },
            {
              url: "/form/contractPR/HOD Rejected Contract",
              name: "PR Rejected",
              slug: "app-user-edit",
              i18n: "Edit",
              permissionName: "Submitted HOD",
            },
          ],
        },
        //--------------------------------------------------------------
        // Contract PR for HOD=====================
        {
          url: null,
          name: "Contract PR Approval",
          icon: "CodepenIcon",
          permissionName: "HOD Contract Approver",
          submenu: [
            {
              url: "/form/contractPR/HOD Pending Contract",
              name: "Pending Approval",
              slug: "new-contract",
              i18n: "View",
              permissionName: "HOD Pending Contract",
            },
            {
              url: "/form/contractPR/HOD Approved Contract",
              name: "Approved By HOD",
              slug: "sent-hod-contract",
              i18n: "View",
              permissionName: "HOD Approved Contract",
            },
            {
              url: "/form/contractPR/HOD Rejected Contract",
              name: "Rejected By HOD",
              slug: "rejected-contract",
              i18n: "View",
              permissionName: "HOD Rejected Contract",
            },
          ],
        },

        {
          url: null,
          name: "Finance Manager",
          icon: "DatabaseIcon",
          i18n: "Finance Manager",
          permissionName: "View PO",
          submenu: [
            {
              url: "/form/PO/PO Pending Approval",
              name: "Pending PO",
              slug: "pending-po",
              i18n: "View",
              permissionName: "PO Pending Approval",
            },
            {
              url: "/form/PO/Submitted To MD",
              name: "PO You Approved",
              slug: "approve-po",
              i18n: "View",
              permissionName: "PO Submitted To MD",
            },
            {
              url: "/form/PO/PO Rejected By FM",
              name: "PO You Rejected",
              slug: "reject-po",
              i18n: "View",
              permissionName: "PO Rejected By FM",
            },

            {
              url: "/form/PO/poApprovedByMD",
              name: "PO Approved By MD",
              slug: "approve-po",
              i18n: "View",
              permissionName: "PO Submitted To MD",
            },
            {
              url: "/form/PO/PORejectedByMD",
              name: "PO Rejected By MD",
              slug: "reject-po",
              i18n: "View",
              permissionName: "PO Rejected By FM",
            },
            {
              url: "/form/PO/poToClose",
              name: "PO To Close",
              slug: "approve-po",
              i18n: "View",
              permissionName: "PO TO CLOSE",
            },
            {
              url: "/form/PO/CLOSED PO",
              name: "Closed PO",
              slug: "approve-po",
              i18n: "View",
              permissionName: "CLOSED PO",
            },
          ],
        },

        {
          url: null,
          name: "Managing Director",
          icon: "DatabaseIcon",
          i18n: "MD",
          permissionName: "View MD PO",
          submenu: [
            {
              url: "/dashboard/md",
              name: "Dashboard",
              slug: "dashboard",
              icon: "HomeIcon",
              permissionName: "Dashboard MD",
            },
            {
              url: "/form/PO/submittedToMD",
              name: "Pending PO",
              slug: "pending-po",
              i18n: "View",
              permissionName: "Submitted To MD",
            },

            {
              url: "/form/PO/PO Rejected By MD",
              name: "Rejected PO",
              slug: "reject-po",
              i18n: "View",
              permissionName: "PO Rejected By MD",
            },
            {
              url: "/form/PO/APPROVED PO",
              name: "Approve PO",
              slug: "approve-po",
              i18n: "View",
              permissionName: "PO APPROVED BY MD",
            },
          ],
        },

        {
          url: null,
          name: "Revise PO",
          icon: "DatabaseIcon",
          i18n: "Pr Manager",
          permissionName: "PO Submitted To MD",
          submenu: [
            //FOR BRANCH USER========================================================================
            {
              url: "/form/PO/poApprovedByMDForRevised",
              name: "PO Approved By MD",
              slug: "approve-po",
              i18n: "View",
              permissionName: "PO Submitted To MD",
            },
            {
              url: "/form/PO/poRevised",
              name: "PO Revised",
              slug: "approve-po",
              i18n: "View",
              permissionName: "PO Submitted To MD",
            },
            {
              url: "/form/PO/canceledPO",
              name: "Canceled PO",
              slug: "canceled-po",
              i18n: "View",
              permissionName: "PO Submitted To MD",
            },
          ],
        },

        {
          url: null,
          name: "PR Manager",
          icon: "DatabaseIcon",
          i18n: "Pr Manager",
          permissionName: "PR Manager",
          submenu: [
            //FOR BRANCH USER========================================================================
            {
              url: "/form/PR/newPr",
              name: "New PR",
              slug: "pr-new",
              i18n: "View",
              permissionName: "New PR",
            },
            {
              url: "/form/PR/Submitted HOD",
              name: "Pending Approval",
              slug: "app-user-edit",
              i18n: "Edit",
              permissionName: "Submitted HOD",
            },
            {
              url: "/form/PR/userApprovedPR",
              name: "Approved By HOD",
              slug: "app-user-edit",
              i18n: "Edit",
              permissionName: "User Approved PR",
            },

            {
              url: "/form/PO/viewPOSubmittedToMD",
              name: "PO Approved Finance",
              slug: "approve-po-finance",
              i18n: "View",
              permissionName: "User Approved PR",
            },

            {
              url: "/form/PO/viewPOApproveMD",
              name: "PO Approved MD",
              slug: "approve-po-md",
              i18n: "View",
              permissionName: "User Approved PR",
            },

            {
              url: "/form/PR/userApprovedByProcurement",
              name: "Approved By Procurement",
              slug: "app-user-edit",
              i18n: "Edit",
              permissionName: "User Approved PR",
            },
            {
              url: "/form/PR/HOD Approved PR",
              name: "Approved PR",
              slug: "app-user-edit",
              i18n: "Edit",
              permissionName: "HOD Approved PR",
            },
            {
              url: "/form/PR/Rejected by Procurement",
              name: "Rejected By Procurement",
              slug: "pr-list",
              i18n: "My Rejected PR",
              permissionName: "User Rejected PR",
            },

            {
              url: "/form/PR/Rejected PR",
              name: "Rejected By HOD",
              slug: "app-user-edit",
              i18n: "Edit",
              permissionName: "User Rejected HOD",
            },
            {
              url: "/form/PR/Rejected PR",
              name: "Rejected PR",
              slug: "app-user-edit",
              i18n: "Edit",
              permissionName: "Rejected PR",
            },
            //----------------------------------------------------------------------------------------------

            //FOR BRANCH HOD========================================================================
            {
              url: "/form/PR/HOD Pending Approval",
              name: "Pending Approval",
              slug: "app-user-edit",
              i18n: "Edit",
              permissionName: "HOD Pending Approval",
            },
            {
              url: "/form/PR/submittedToPr",
              name: "Approved PR",
              slug: "app-user-edit",
              i18n: "Edit",
              permissionName: "HOD Submitted To PR",
            },
            {
              url: "/form/PR/hodRejectedByhod",
              name: "Rejected By Me",
              slug: "app-user-edit",
              i18n: "Edit",
              permissionName: "HOD Rejected By HOD",
            },
            {
              url: "/form/PR/hodRejectedByPR",
              name: "Rejected By Procurement",
              slug: "app-user-edit",
              i18n: "Edit",
              permissionName: "HOD Rejected By PR",
            },
            //----------------------------------------------------------------------------------------------

            //FOR PROCUREMENT TEAM========================================================================
            {
              url: "/form/PR/pendingApprovalByPR",
              name: "Pending Approval",
              slug: "app-user-edit",
              i18n: "Edit",
              permissionName: "Submitted PR Team",
            },
            {
              url: "/form/PR/PO Generated",
              name: "PO Generated",
              slug: "app-user-edit",
              i18n: "Edit",
              permissionName: "PO Generated",
            },
            {
              url: "/form/PR/Rejected by Procurement",
              name: "Rejected PR",
              slug: "app-user-edit",
              i18n: "red",
              permissionName: "Rejected by Procurement",
            },
            //----------------------------------------------------------------------------------------------
          ],
        },

        {
          url: "/form/vendor/profile",
          name: "Vendor Profile",
          slug: "Vendor Profile",
          icon: "UserIcon",
          tagColor: "success",
          i18n: "Vendor Profile",
          permissionName: "Vendor Profile",
        },

        {
          url: null,
          name: "Vendor Manager",
          icon: "UserCheckIcon",
          i18n: "User",
          permissionName: "Vendor Manager",
          submenu: [
            {
              url: "/form/vendor/Pending Approval Vendors",
              name: "Pending Approval Vendors",
              slug: "app-user-edit",
              i18n: "Edit",
              permissionName: "Pending Approval Vendors",
            },
            {
              url: "/form/vendor/Approved Vendors",
              name: "Approved Vendors",
              slug: "app-user-edit",
              i18n: "Edit",
              permissionName: "Approved Vendors",
            },
            {
              url: "/form/vendor/Rejected Vendors",
              name: "Rejected Vendors",
              slug: "app-user-edit",
              i18n: "Edit",
              permissionName: "Rejected Vendors",
            },
          ],
        },
        //FOR GRN======================================================================================
        {
          url: null,
          name: "GRN Manager",
          icon: "UserCheckIcon",
          i18n: "User",
          permissionName: "add GRN",
          submenu: [
            {
              url: "/form/GRN/grns",
              name: "Add GRN",
              slug: "addGRN",
              i18n: "addGRN",
              permissionName: "add GRN",
            },
          ],
        },
        {
          url: null,
          name: "GRN for PR",
          icon: "UserCheckIcon",
          i18n: "User",
          permissionName: "view GRN",
          submenu: [
            {
              url: "/form/GRN/allgrns",
              name: "View GRN",
              slug: "addGRN",
              i18n: "addGRN",
              permissionName: "view GRN",
            },
          ],
        },

        //----------------------------------------------------------------------------------------------

        //FOR Adjustment Approver======================================================================================

        {
          url: null,
          name: "Adjustment Approver",
          icon: "UserCheckIcon",
          i18n: "User",
          permissionName: "Pending Adjustment",
          submenu: [
            {
              url: "/form/adjustments/HOD Pending Approval",
              name: "Pending Adjustments",
              slug: "pendingAN",
              i18n: "pendingAN",
              permissionName: "Pending Adjustment",
            },
            {
              url: "/form/adjustments/Approved Adjustment",
              name: "Approved Adjustment",
              slug: "viewApprovedAN",
              i18n: "viewApprovedAN",
              permissionName: "Approved Adjustment",
            },
            {
              url: "/form/adjustments/Rejected Adjustment",
              name: "Rejected Adjustment",
              slug: "viewRejectedAN",
              i18n: "viewRejectedAN",
              permissionName: "Rejected Adjustment",
            },
          ],
        },
        //----------------------------------------------------------------------------------------------
        //FOR Adjustment Manager======================================================================================
        {
          url: null,
          name: "Adjustment Manager",
          icon: "UserCheckIcon",
          i18n: "User",
          permissionName: "Add Adjustment",
          submenu: [
            {
              url: "/form/adjustments/New Adjustments",
              name: "Add Adjustments",
              slug: "addAN",
              i18n: "addAN",
              permissionName: "Add Adjustment",
            },
            {
              url: "/form/adjustments/View Pending Adjustment",
              name: "View Pending Adjustment",
              slug: "viewPendingAN",
              i18n: "viewPendingAN",
              permissionName: "View Pending Adjustment",
            },
            {
              url: "/form/adjustments/View Approved Adjustment",
              name: "View Approved Adjustment",
              slug: "viewApprovedAN",
              i18n: "viewApprovedAN",
              permissionName: "View Approved Adjustment",
            },
            {
              url: "/form/adjustments/View Rejected Adjustment",
              name: "View Rejected Adjustment",
              slug: "viewRejectedAN",
              i18n: "viewRejectedAN",
              permissionName: "View Rejected Adjustment",
            },
          ],
        },
        //----------------------------------------------------------------------------------------------

        {
          header: "Settings",
          icon: "PieChartIcon",
          i18n: "ChartsAndMaps",
          permissionName: "Settings",
          items: [
            {
              url: "/settings",
              name: "System Settings",
              icon: "SettingsIcon",
              slug: "settings",
              i18n: "Settings",
              permissionName: "settings",
            },

            {
              url: null,
              name: "Master Tables",
              icon: "GridIcon",
              tagColor: "success",
              i18n: "Charts",
              permissionName: "Master Tables",
              submenu: [
                {
                  url: "/view/departments",
                  name: "Departments",
                  slug: "extra-component-charts-apex-charts",
                  i18n: "ApexCharts",
                  permissionName: "Departments",
                },
                {
                  url: "/view/branches",
                  name: "Branches",
                  slug: "extra-component-charts-apex-charts",
                  i18n: "ApexCharts",
                  permissionName: "Branches",
                },
                {
                  url: "/view/companyTypes",
                  name: "Company Types",
                  slug: "extra-component-charts-apex-charts",
                  i18n: "ApexCharts",
                  permissionName: "Company Types",
                },
                {
                  url: "/view/businessTypes",
                  name: "Business Types",
                  slug: "extra-component-charts-apex-charts",
                  i18n: "ApexCharts",
                  permissionName: "Business Types",
                },
                {
                  url: "/view/currencies",
                  name: "Currencies",
                  slug: "extra-component-charts-apex-charts",
                  i18n: "ApexCharts",
                  permissionName: "Currencies",
                },
                {
                  url: "/view/billingAddresses",
                  name: "Billing Addresses",
                  slug: "extra-component-charts-apex-charts",
                  i18n: "ApexCharts",
                  permissionName: "Billing Addressess",
                },

                {
                  url: "/view/users",
                  name: "System Users",
                  slug: "extra-component-charts-apex-charts",
                  i18n: "ApexCharts",
                  permissionName: "System Users",
                },
              ],
            },
          ],
        },
      ],

      routerTransition: themeConfig.routerTransition || "none",
      routeTitle: this.$route.meta.pageTitle,
    };
  },

  computed: {
    ...mapGetters({ getPermissions: "auth/getPermissions" }),
    filteredNav() {
      var menuItemCopy = this.navMenuItems;

      if (this.getPermissions != null) {
        var myPermission = this.getPermissions;
        var mainFilter = menuItemCopy.filter((f) =>
          myPermission.includes(f.permissionName)
        );

        //filter sub menus
        mainFilter.forEach((element) => {
          if (this.isset(element, "submenu")) {
            element.submenu = element.submenu.filter((f) =>
              myPermission.includes(f.permissionName)
            );
          }

          if (this.isset(element, "items")) {
            element.items = element.items.filter((f) =>
              myPermission.includes(f.permissionName)
            );

            element.items.forEach((el) => {
              if (this.isset(el, "submenu")) {
                el.submenu = el.submenu.filter((f) =>
                  myPermission.includes(f.permissionName)
                );
              }
            });
          }
        });

        return mainFilter;
      } else {
        this.$router.push("/pages/login").catch(() => {});
      }
    },
    bodyOverlay() {
      return this.$store.state.main.bodyOverlay;
    },
    contentAreaClass() {
      if (this.mainLayoutType === "vertical") {
        if (this.verticalNavMenuWidth == "default")
          return "content-area-reduced";
        else if (this.verticalNavMenuWidth == "reduced")
          return "content-area-lg";
        else return "content-area-full";
      }
      // else if(this.mainLayoutType === "boxed") return "content-area-reduced"
      else return "content-area-full";
    },
    footerClasses() {
      return {
        "footer-hidden": this.footerType == "hidden",
        "footer-sticky": this.footerType == "sticky",
        "footer-static": this.footerType == "static",
      };
    },
    isAppPage() {
      return this.$route.meta.no_scroll;
    },
    isThemeDark() {
      return this.$store.state.main.theme == "dark";
    },
    layoutTypeClass() {
      return `main-${this.mainLayoutType}`;
    },
    mainLayoutType() {
      return this.$store.state.main.mainLayoutType;
    },
    navbarClasses() {
      return {
        "navbar-hidden": this.navbarType == "hidden",
        "navbar-sticky": this.navbarType == "sticky",
        "navbar-static": this.navbarType == "static",
        "navbar-floating": this.navbarType == "floating",
      };
    },
    verticalNavMenuWidth() {
      return this.$store.state.main.verticalNavMenuWidth;
    },
    windowWidth() {
      return this.$store.state.main.windowWidth;
    },
  },

  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
    },
    isThemeDark(val) {
      const color = this.navbarColor == "#fff" && val ? "#10163a" : "#fff";
      this.updateNavbarColor(color);
    },
    "$store.state.main.mainLayoutType"(val) {
      this.setNavMenuVisibility(val);
    },
  },

  created() {
    //this.$store.dispatch("auth/getPermission");

    const color =
      this.navbarColor == "#fff" && this.isThemeDark
        ? "#10163a"
        : this.navbarColor;
    this.updateNavbarColor(color);
    this.setNavMenuVisibility(this.$store.state.main.mainLayoutType);
  },

  methods: {
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateNavbarColor(val) {
      this.navbarColor = val;
      if (val == "#fff") this.isNavbarDark = false;
      else this.isNavbarDark = true;
    },
    setNavMenuVisibility(layoutType) {
      if (
        (layoutType === "horizontal" && this.windowWidth >= 1200) ||
        (layoutType === "vertical" && this.windowWidth < 1200)
      ) {
        this.$store.commit("main/TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);
        this.$store.dispatch("main/updateVerticalNavMenuWidth", "no-nav-menu");
      } else {
        this.$store.commit("main/TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
      }
    },
  }
};
</script>

